export default function CurrencyLatestSeperator(amount) {
  // Convert the amount to a fixed 2 decimal places
  const fixedAmount = Number(amount).toFixed(2);

  // Use Intl.NumberFormat to format the number with thousands separators
  const formattedValue = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(fixedAmount);

  return formattedValue;
}
